import { isFunction } from 'lodash';
import type { FC, ReactElement } from 'react';
import { memo } from 'react';

import { Dialog, DialogContent, Typography } from '@mui/material';

import noAppImg from 'img/site/site_no-appointments_offline.svg';

import { CISecondaryButton } from 'common/viewcomp/forms/buttons';

import './firstofflinelogin.modal.scss';

interface Props {
    t: Function;
    onClose: () => void;
    open: boolean;
}

const FirstOfflineLoginModal: FC<Props> = (props): ReactElement => {
    const { t, open, onClose } = props;

    const handleClose = (_, reason: 'backdropClick' | 'escapeKeyDown'): boolean | void => {
        if (reason === 'backdropClick') {
            return false;
        }

        if (isFunction(onClose)) {
            onClose();
        }
    };

    if (!open) {
        return <></>;
    }

    return (
        <Dialog maxWidth="xs" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogContent>
                <div className="first-offline-login first-offline-login-container">
                    <img src={noAppImg} alt="Offline appointments not available" />
                    <Typography className="first-offline-login-title" variant="h4">
                        {t('first_offline_login.no_internet')}
                    </Typography>
                    <Typography className="first-offline-login-body" variant="subtitle2">
                        {t('first_offline_login.message')}
                    </Typography>

                    <CISecondaryButton
                        onClick={onClose}
                        className="first-offline-login-button"
                        type="submit"
                        id="backTologinButton"
                    >
                        {t('first_offline_login.back_to_login')}
                    </CISecondaryButton>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default memo(FirstOfflineLoginModal, (prevProps, nextProps): boolean => nextProps.open === prevProps.open);
